import React, { useEffect, useState } from 'react';
import MetricsTable from '@/pages/intelligence/pages/TopCharts/PCGames/MetricsTable';
import { buriedPointPage } from '@/pages/home/utils/buriedPoint';
import { dbiPageLogMes } from '@/pages/intelligence/utils/buriedPointCfg';
import { TopchartPageId } from '@intelligence/pages/TopCharts/_config/topChartsConst';
import { digitalRevenueList } from '@/pages/intelligence/pages/TopCharts/_config/metricOptions';
import * as filterKeyMap from '@/pages/intelligence/components/Filter/FilterBase/_config';
import moment from 'moment';
import useMarketFilterApi, {
  MarketSpecailType,
} from '@/pages/intelligence/hooks/useMarketSelector';
import { getDeviceValuesByPageId } from '@/pages/intelligence/pages/TopCharts/PCGames/_config/utils';
import {
  commonPCConsoleDefaultFilterValue,
  handleMetricTableFilterParamsToApi,
} from '@/pages/intelligence/pages/TopCharts/_config/topchartFilterCfg';
import { FilterTimeType } from '@intelligence/utils/filterUtils';
import useEarliesTimeHasData from '@/pages/intelligence/hooks/useEarliesTimeHasData';
import { hasDataTimerParams } from '@intelligence/utils/timerDefautParams';
import { defaultMetrictableApiParams } from '@intelligence/pages/TopCharts/PCGames/MetricsTable/utils/constant';
import { useIntl, history } from 'umi';
import { getTopPCMetricTableCustomValidUrlParams, topchartConsoleDigitalRevenueValidCfg, hasShortLinkRatio } from '@intelligence/_config/urlPageValidCfg';
import { getOriginalShortLinkFilter, URL_FILTER_KEY, URL_CHART_METRIC, URL_CHART_TYPE } from '@intelligence/utils/urlPathCfg';
import MarqueeBanner from '@intelligence/components/MarqueeBanner/index';

export default function DigitalRevenue() {
  const { formatMessage } = useIntl(); // 中英切换方法
  const pageId = TopchartPageId.DigitalRevenue;
  const entityType = 'console';

  const { filterLoading, regionOptions } = useMarketFilterApi({
    filterType: MarketSpecailType.digitalRevenue,
  });

  const { latestTimeTypeHasData } = useEarliesTimeHasData({
    filterType: hasDataTimerParams?.consoleDigitalRevenue?.type,
  });

  const hasUrlShortLink = hasShortLinkRatio.topConsoleDigitalRevenue;
  const [shortLinkLoading, setShortLinkLoading] = useState(hasUrlShortLink);
  const [urlCustomParams, setUrlCustomParams] = useState({});
  const [shortLinkValidQuery, setShortLinkValidQuery] = useState({
    [URL_CHART_TYPE]: topchartConsoleDigitalRevenueValidCfg?.[URL_CHART_TYPE]?.[0],
    [URL_CHART_METRIC]: topchartConsoleDigitalRevenueValidCfg?.[URL_CHART_METRIC]?.[0],
  });
  const [shortLinkFilterValue, setShortLinkFilterValue] = useState(null);

  const initPage = async () => {
    setShortLinkLoading(true);
    // 在url上取token，有则请求接口， 判断异常，返回函数值和url上的其他配置参数
    const { [URL_FILTER_KEY]: urlFilter } = await getOriginalShortLinkFilter();
    if (urlFilter) {
      // 有的筛选器的token时才用后面的参数，没有则不用
      const { params, validQuery } = getTopPCMetricTableCustomValidUrlParams(history, topchartConsoleDigitalRevenueValidCfg, digitalRevenueList);
      setUrlCustomParams({ ...params });
      setShortLinkValidQuery({ ...shortLinkValidQuery, ...validQuery });
      setShortLinkFilterValue(urlFilter);
    }
    setShortLinkLoading(false);
  };

  useEffect(() => {
    buriedPointPage(dbiPageLogMes.topChartsConsoleGamesDigitalRevenue);
    // 进入页面时判断是否有tokenQuery等，有则进入
    initPage();
  }, []);

  const defaultFilterValue = {
    ...commonPCConsoleDefaultFilterValue,
    [filterKeyMap.REGION]: {
      // regions: ['na'],
      regions: [],
      markets: ['us'],
      type: 'region',
    },
    [filterKeyMap.DIGITAL_DEVICE]: {
      value: getDeviceValuesByPageId(pageId),
    },
  };

  const filterCfg = {
    filterKeyList: [
      filterKeyMap.MY_FILTER,
      filterKeyMap.RANGE_TIME,
      filterKeyMap.REGION,
      filterKeyMap.GENRETOR,
      filterKeyMap.ALL_Games,
      filterKeyMap.DIGITAL_SEGEMENT,
      filterKeyMap.DIGITAL_DEVICE,
      filterKeyMap.ALL_COMPANYS,
      filterKeyMap.RELEASE_TIME,
    ],
    companyFilterParams: {
      entity_type: entityType,
      source: 'mscience',
      metric: 'revenue',
      region_type: 'market',
      regions: ['global'],
      granularity: 'monthly',
      start_date: '2023-12-26',
      end_date: '2024-01-24',
      data_sources: ['mscience'],
      page_size: 500,
      search_name: '',
      page: 1,
      source_metric: {
        mscience: ['revenue'],
      },
    },
    regionFilterParams: {},
    defaultValue: defaultFilterValue,
    resetFilterValue: {
      ...defaultFilterValue,
      [filterKeyMap.RANGE_TIME]: {
        type: 'month',
        value: [moment().subtract(6, 'months'), moment().subtract(1, 'months')],
      },
    },
    specialParams: {
      regionOptions, // 国家筛选器options,
      defalutMarket: ['us'], // 没取到交集用的默认值
      disableNoChina: true,
      rangeTimeType: FilterTimeType.commonRange,
      disableIegg: false,
      disableAnnie: true,
      [filterKeyMap.ALL_Games]: {
        params: { entity_type: entityType, game_type: 'current_game' },
      },
      entityType
    },
    showConfirmButton: true,
    haveFilterSaveBtn: true,
    handleFilterToApiParams: (params: any) => handleMetricTableFilterParamsToApi(params, entityType),
    hasUrlShortLink,
  };

  const defaultParams = {
    ...defaultMetrictableApiParams,
    entity_type: entityType,
    order_metric: 'digitalRevenue',
    order_source: 'mscience',
    source_metrics: {
      mscience: ['digitalRevenue', 'units', 'digitalARPPU', 'ast'],
    },
    topchart_name: 'Digital Revenue',
    region_type: 'market',
    regions: ['us'],
    date_type: 'monthly',
    device: getDeviceValuesByPageId(pageId),
  };

  return (
    <>
      <MarqueeBanner />
      <MetricsTable
        entityType={entityType}
      pageId={pageId}
      pageLogInfo={dbiPageLogMes.topChartsConsoleGamesDigitalRevenue}
      tableCloumsList={digitalRevenueList}
      hasRegionFilter={true}
      cardMetricName={formatMessage({ id: 'dbi_digital_revenue' })}
      filterCfg={filterCfg}
      filterLoading={filterLoading || shortLinkLoading}
      rangeTimeComponentDefault={latestTimeTypeHasData}
      defaultParams={defaultParams}
      urlCustomParams={urlCustomParams}
      shortLinkValidQuery={shortLinkValidQuery}
      shortLinkFilterValue={shortLinkFilterValue}
    />
    </>
  );
}
